import {isRegExp, isFunction} from 'lodash/fp'

function validate(rule, string) {

  const ruleTable = new Map()
  ruleTable.set('nonEmpty', /.+/)

  if(ruleTable.has(rule)) {
    return ruleTable.get(rule).test(string)
  }

  if(isRegExp(rule)) {
    return rule.test(string)
  }

  if(isFunction(rule)) {
    return rule(string)
  }

  return false
}

function validateField(rules, string) {
  let validateArray = rules.map(rule => ({name: rule.rule, message: rule.message, error: ! validate(rule.rule, string)})).filter(rule => rule.error === true)
  return validateArray
}

export {validateField}


// WEBPACK FOOTER //
// ./src/formWizard/validate/validate.js